import { FC } from 'react';
import { Icon } from '@lambdacurry/component-library';
import { Card, CardContent } from 'lib/components';
import { MyOrdersQuery } from 'lib/home/generated/types/api';
import { medusaPriceAmountToMoney } from 'lib/home/util/currency';
import { selectCardInfoFromMedusaOrder } from '../../util/helpers';
export interface ProductPaymentProps {
  order: MyOrdersQuery['customerOrders'][number];
}

export const ProductPayment: FC<ProductPaymentProps> = ({ order }) => {
  const { last4, brand } = selectCardInfoFromMedusaOrder(order);
  const orderPlan = order.cart.items.find(item => item.variant?.product?.collection?.handle === 'subscriptions');

  return (
    <Card className="bg-inherit p-4 mt-0">
      <CardContent className="!p-0">
        <div className="flex justify-between items-center flex-wrap mb-2">
          <h3 className="mb-2">Payment</h3>
          <div className="flex">
            <Icon name="info" className="mr-4 mb-2 min-w-[24px]" />
            <a data-cy="payment-method-link" className="mr-4" href="/account/payment-methods/">
              manage payment methods
            </a>
          </div>
        </div>

        <div className="flex flex-col !justify-center">
          <div className="flex">
            <p className="my-2 mr-2 font-medium"> Charged </p>
            <p className="my-2 mr-2 capitalize font-medium">{brand}</p>
            <p className="my-2 font-medium">{last4}</p>
          </div>

          <div>
            {orderPlan && (
              <div className="flex justify-between">
                <p className="my-2">{orderPlan?.title}/ week</p>
                <p className="my-2">{medusaPriceAmountToMoney(orderPlan.unit_price)}</p>
              </div>
            )}
            {order.discount_total !== 0 && (
              <div className="flex justify-between ">
                <p className="my-2">Discount</p>
                <p className="my-2">{medusaPriceAmountToMoney(order.discount_total)}</p>
              </div>
            )}

            {/* Note: Shipping is currently free so we're not showing any content here if there is no shipping_total */}
            <div className="w-full ">
              {order.shipping_total ? (
                <div className="flex justify-between">
                  <p className="my-2">Shipping</p>
                  <p className="my-2"> {medusaPriceAmountToMoney(order.shipping_total)}</p>
                </div>
              ) : null}
            </div>

            <div className="flex justify-between ">
              <p>Estimated tax</p>
              <p>{medusaPriceAmountToMoney(order.tax_total)}</p>
            </div>

            <hr />

            <div className="flex justify-between  mt-2">
              <p className="my-2 font-medium">Total</p>
              <p className="my-2 font-medium" id="total-price">
                {medusaPriceAmountToMoney(order.total)}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
